import axios from "./AxiosInstance"

const getAllAxis = (hasSurvey = undefined) => {
    let additionalUrl = ""

    if (hasSurvey) {
        additionalUrl += "?hasSurvey=1"
    }

    return axios.get(`api/axis${additionalUrl}`)
}
const getAlldiagnosis = (userId) => axios.get(`api/patients/${userId}/educationalDiagnosis/current`)
const getAlldiagnosisStatus = () => axios.get(`api/diagnosisStatus`)
const createEducationnalDiagnosis = (statusId) => axios.post(`api/educationalDiagnosis`, { statusId: statusId })
const getUserDEList = (userId) => axios.get(`api/educationalDiagnosis?paginated=false&userId=${userId}`)
const updateEducationnalDiagnosis = (id, statusId) =>
    axios.put(`api/educationalDiagnosis/${id}`, { statusId: statusId })
const deleteEducationnalDiagnosis = (id) => axios.delete(`api/educationalDiagnosis/${id}`)
const mentionProfessional = (payload) => axios.post("api/patients/healthProfessionals", { ...payload })

export const EducatifDiagnoseService = {
    getUserDEList,
    getAllAxis,
    getAlldiagnosis,
    getAlldiagnosisStatus,
    createEducationnalDiagnosis,
    updateEducationnalDiagnosis,
    deleteEducationnalDiagnosis,
    mentionProfessional
}
